import * as React from 'react';
import Reject from './pages/reject';
import { Header } from './components/header';
import { Footer } from './components/footer';
import { FullStory } from './components/fullStory';
import IneligibleRegion from './pages/ineligible-region';

declare global {
    interface Window {
        page: string;
        pageData: Record<string, any>;
    }
}

const isLocal = (): boolean => window.location.hostname === 'localhost';

const getPageContent = (page: string): JSX.Element => {
    if (page === 'ineligible-region') {
        return <IneligibleRegion />;
    }

    return <Reject />;
};

const App = () => {
    const content = getPageContent(window.page);

    return (
        <>
            <Header showBackToLobbyButton={window.pageData.showBackToLobby} />
            {content}
            {!isLocal() && <FullStory />}
            <Footer />
        </>
    );
};

export default App;
